import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnDestroy
} from '@angular/core';
import { PermissionsService } from 'src/app/system/admin/pages/catalogs/services/permissions.service';
import { Subject, combineLatest, takeUntil } from 'rxjs';

@Directive({
  selector: '[appHasPermission]',
  standalone: true,
})
export class HasPermissionDirective implements OnDestroy {

  private moduleName!: string;
  private destroy$ = new Subject<void>();
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionsService
  ) {
    combineLatest([
      this.permissionService.permissions$,
      this.permissionService.ready$
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([_, ready]) => {
        if (ready) {
          this.updateView();
        }
      });
  }

  @Input('appHasPermission')
  set moduleLabel(label: string) {
    this.moduleName = label;
    this.updateView();
  }

  private updateView(): void {
    if (!this.moduleName) return;

    const hasPermission =
      this.permissionService.hasPermission(this.moduleName);

    if (hasPermission && !this.hasView) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }

    if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
